import Immutable from 'immutable'

export const EMPTY_STR = ''
export const EMPTY_ARRAY = Object.freeze([])
export const EMPTY_OBJ = Object.freeze({})
export const EMPTY_IMMUTABLE_MAP = Immutable.Map()
export const EMPTY_IMMUTABLE_LIST = Immutable.List()
export const EMPTY_IMMUTABLE_SET = Immutable.Set()
export const EMPTY_IMMUTABLE_ORDERED_SET = Immutable.Set()

export const SPACE = ' '
export const SLASH = '/'
export const DASH = '-'
export const EQUAL = '='
export const UNDERSCORE = '_'
export const STAR = '*'
export const AT = '@'
export const AMPERSAND = '&'
export const QUESTION_MARK = '?'
export const COLON = ':'
export const SEMICOLON = ';'
export const DOT = '.'
export const COMMA = ','
export const PIPE = '|'
export const HASH = '#'
export const NOT_AVAILABLE = '_NA_'
export const QUOTE = '\''
export const QUOTES = '"'

export const UPDATE_THRESHOLD = 0.8

export const ISO8601_PATTERN = 'YYYY-MM-DDTHH:mm:ss.sssZ'

export function identity(x) {
    return x
}

export function emptyFunction() { }

export const FLAG_Y = 'Y'
export const FLAG_N = 'N'

export const READ_ONLY_SYMBOL = '🚫'
